import React, {useEffect, useState} from 'react';

import './RevisionsTable.scss';
import {Empty, Table} from 'antd';

import InfiniteScroll from 'react-infinite-scroll-component';
import http from '../../../../services/httpService';

import {Spinner} from 'react-bootstrap';
import {getAllRevisions} from '../../../../services/revisions';
import FindingsTable from './FindingsTable';
import {getLanguage} from 'react-switch-lang';

const RevisionsTable = ({
  api,
  query,
  sort,
  queryParamName,
  columns,
  rows = 20,
  methods,
  addButtonRef,
  modalEdit = false,
  locale,
  actionsRedirect,
  actionsWidth,
  onClickRow,
  actionsOpenModal,
  updateTable,
  onColumnAdd,
  onColumnEdit,
  onColumnDelete,
  subTableColumns,
  subTableClickRow,
  roles,
  ...rest
}) => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [page, setPage] = useState(0);
  const [subtableData, setSubtableData] = useState(null);
  const [sortFilter, setSortFilter] = useState('');

  const lang = getLanguage();

  const fetchData = async () => {
    try {
      const {data} = await http.get(
        `${api}?page=0&size=${rows}&${query}&${sortFilter}`
      );
      setItems(data?.content);
      setHasMore(data?.content.length === rows);
      setPage((page) => page + 1);
    } catch (err) {}
  };

  const fetchMoreData = async () => {
    try {
      const {data} = await http.get(
        `${api}?page=${page}&size=${rows}&${query}&${sortFilter}`
      );
      setItems([...items, ...data?.content]);
      setHasMore(data?.content?.length === rows);
      setPage((page) => page + 1);
    } catch (err) {}
  };

  useEffect(() => {
    fetchData();
  }, [query, sortFilter]);

  const onTableChange = (pagination, filters, sorter) => {
    if (sorter?.column) {
      setSortFilter(
        `sort=${sorter?.columnKey},${
          sorter.order === 'ascend' ? 'ASC' : 'DESC'
        }`
      );
    } else {
      setSortFilter('');
    }
  };

  const loader = (
    <div className="text-center mt-3">
      <Spinner variant="primary" animation="border" />
    </div>
  );

  return (
    <div style={{paddingBottom: '50px'}}>
      <InfiniteScroll
        next={fetchMoreData}
        hasMore={hasMore}
        loader={loader}
        scrollableTarget="app-body"
        dataLength={items.length}
      >
        <Table
          columns={columns}
          showSorterTooltip={false}
          locale={{
            emptyText: (
              <Empty
                description={lang === 'mne' ? 'Nema podataka' : 'No data'}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ),
          }}
          rowKey={'id'}
          onChange={onTableChange}
          onRow={(record, rowIndex) => {
            return {
              onClick: async (event) => {
                onClickRow(record);
              }, // click row
            };
          }}
          expandable={{
            onExpand: async (event, rowData) => {
              setSubtableData(await getAllRevisions());
            },
            expandedRowRender: (record) => (
              <FindingsTable
                prefixCls={'subTable'}
                pagination={false}
                columns={subTableColumns}
                onClickRow={subTableClickRow}
                api={'/findings'}
                query={`revisionId.equals=${record?.id}`}
                revisionId={record?.id}
              />
            ),
            expandIcon: ({expanded, onExpand, record}) =>
              expanded ? (
                <img
                  width={19}
                  height={19}
                  src={process.env.PUBLIC_URL + '/images/rightArrow.svg'}
                  onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                />
              ) : (
                <img
                  width={19}
                  height={19}
                  src={process.env.PUBLIC_URL + '/images/downArrow.svg'}
                  onClick={async (e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                />
              ),
          }}
          dataSource={items}
          sticky={true}
          pagination={false}
        />
      </InfiniteScroll>
    </div>
  );
};

export default RevisionsTable;
